import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'desisntallationMotives': [],
  'loadingId': false,
  'newRequestId': '',
  'loadingDetail': false,
  'requestDetail': {},
  'loadingVehicleInfoList': false,
  'vehicleInfoList': [],
};

export const requestsDevice = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_REQUESTS_DEVICE_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_REQUESTS_DEVICE_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_REQUESTS_DEVICE_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.ADDING_REQUESTS_DEVICE]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.ADDED_REQUESTS_DEVICE]: (state, action) => ({
      ...state,
      'loadingDetail': false,
    }),
    [ActionTypes.ADDED_REQUESTS_DEVICE_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
    }),
    [ActionTypes.FETCHING_REQUEST_ID]: (state, action) => ({
      ...state,
      'loadingId': true,
    }),
    [ActionTypes.FETCHED_REQUEST_ID]: (state, action) => ({
      ...state,
      'loadingId': false,
      'newRequestId': action.response.data,
    }),
    [ActionTypes.FETCHED_REQUEST_ID_FAILED]: (state, action) => ({
      ...state,
      'loadingId': false,
      'newRequestId': '',
    }),
    [ActionTypes.FETCHING_DESISNTALLATION_MOTIVES_LIST]: (state, action) => ({
      ...state,
      'loadingId': true,
    }),
    [ActionTypes.FETCHED_DESISNTALLATION_MOTIVES_LIST]: (state, action) => ({
      ...state,
      'loadingId': false,
      'desisntallationMotives': action.response.data,
    }),
    [ActionTypes.FETCHED_DESISNTALLATION_MOTIVES_LIST_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingId': false,
      'desisntallationMotives': [],
    }),
    [ActionTypes.FETCHING_REQUEST_DEVICE_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.FETCHED_REQUEST_DEVICE_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'requestDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_REQUEST_DEVICE_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'requestDetail': {},
    }),
    [ActionTypes.FETCHING_VEHICLES_INFO_LIST_BY_SEARCH]: (state, action) => ({
      ...state,
      'loadingVehicleInfoList': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_INFO_LIST_BY_SEARCH]: (state, action) => ({
      ...state,
      'loadingVehicleInfoList': false,
      'vehicleInfoList': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_INFO_LIST_BY_SEARCH_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingVehicleInfoList': false,
      'vehicleInfoList': [],
    }),
    [ActionTypes.CLEAR_VEHICLES_INFO_LIST_BY_SEARCH]: (state, action) => ({
      ...state,
      'loadingVehicleInfoList': false,
      'vehicleInfoList': [],
    }),
    [ActionTypes.CLEAR_REQUESTS_DEVICE_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
